/// <amd-module name="VSS/Platform/Components/FPSLink" />
export * from "./FPSLink/FPSLink";
export { FPSLinkComponentProps } from "./FPSLink/FPSLink.Props";
